<template>

  <!-- Dispatched (DISPATCHED, DISPATCHED_EDITING) -->
  <route-list-data-table
      title="Dispatched"
      defaultSortField="dispatched_at"
      defaultSortOrder="dsc"
      :headers="headers"
      :status="status"
      :assocs="assocs"
      routeClickGoTo="route-info" />

</template>

<script>
import RouteListDataTable from '@/components/routes/RouteListDataTable'

export default {
  name: 'RouteListDispatchedPage',

  components: {
    RouteListDataTable
  },

  data () {
    return {
      headers: [
        { text: 'Name', align: 'start', value: 'name', width: '18%' },
        { text: 'Orders', sortable: false, value: 'orders', width: '180px' },
        { text: 'Actions', sortable: false, align: 'center', value: 'model' },
        { text: 'Delivery Date', value: 'delivery_date' },
        { text: 'Start At', value: 'scheduled_start_time' },
        { text: 'Est. Return', value: 'estimated_return_time' },
        { text: 'Vehicle', value: 'vehicle_id' },
        { text: 'Driver', value: 'driver_user_id' },
        { text: 'Dispatched', value: 'dispatched_at' },
        { text: 'Status', align: 'start', value: 'route_status' }
      ],
      status: ['DISPATCHED', 'DISPATCHED_EDITING'],
      assocs: 'orders,driver,vehicle'
    }
  }
}
</script>

<style scoped>
</style>
